import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase'; 

const eventTypeCollection = collection(db, "event_types");

const eventTypeService = { 
  getAll: async () => {
    try {  
      const eventTypesSnapshot = await getDocs(eventTypeCollection);
      const eventTypesList = eventTypesSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return eventTypesList;
    } catch (error) {
      console.error('Error fetching eventTypes:', error);
      throw error;
    }
  },
  add: async (eventTypesData) => {
    try {
      const docRef = await addDoc(eventTypeCollection, eventTypesData);
      return docRef;
    } catch (error) {
      console.error('Error adding event types:', error);
      throw error;
    }
  },
  edit: async ({ id, data }) => {
    try {
      const eventTypeRef = doc(db, 'event_types', id);
      await updateDoc(eventTypeRef, data);
    } catch (error) {
      console.error('Error updating event types:', error);
      throw error;
    }
  },
  delete: async (eventTypeId) => {
    try {
     await deleteDoc(doc(db, "event_types", eventTypeId));
     return true;
    } catch (error) {
      console.error('Error deleting event types:', error);
      throw error;
    }
  },

  getNameById: async (eventTypeId) => {
    try {
     const eventTypeRef = doc(db, 'event_types', eventTypeId);
     const eventTypeSnap = await getDoc(eventTypeRef);

     if (eventTypeSnap.exists()) {
       return eventTypeSnap.data().name;  
     }
     else {
       return null; 
     }
    } 
    catch (error) {
      console.error('Error getting event Type name:', error);
      throw error; 
    }
  },

  getById: async (eventTypeId) => {
    try {
      const eventTypeRef = doc(db, 'event_types', eventTypeId);
      const eventTypeSnap = await getDoc(eventTypeRef);

      if (eventTypeSnap.exists()) {
        return {
          id: eventTypeId,
          ...eventTypeSnap.data()
        };
      }
      return null;
    } catch (error) {
      console.error('Error getting event type data:', error);
      throw error;
    }
  },
};

export default eventTypeService;